// extracted by mini-css-extract-plugin
export default {"applyMargin":"BaseFilterDropdown_applyMargin_QE99T","dropdownItem":"BaseFilterDropdown_dropdownItem_tlm63","spinAround":"BaseFilterDropdown_spinAround_YquGs"};